// On Review: use base enum
export const agentOfficeHierarchyStatusTypes = {
	TERMINATED: 1,
	PROSPECTIVE: 2,
	ACTIVE: 3,
	INACTIVE: 4,
};

export const isInactiveAgentStatus = status => {
	return [
		agentOfficeHierarchyStatusTypes.TERMINATED,
		agentOfficeHierarchyStatusTypes.INACTIVE,
	].includes(status);
};
